'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guidName = exports.guidDetails = exports.fetchGuidDetails = exports.reducer = exports.NAME = undefined;
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var NAME = exports.NAME = 'guidDetails';
var actionTypes = {
  FETCH_GUID_DETAILS: NAME + '/FETCH_GUID_DETAILS'
};
var reducer = exports.reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  if (action.type === actionTypes.FETCH_GUID_DETAILS) {
    return action.guidDetails;
  }
  return state;
};
var fetchGuidDetails = exports.fetchGuidDetails = function fetchGuidDetails(guid) {
  return function (dispatch) {
    return _axios2.default.get(process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/advisor/details?guid=' + guid).then(function (response) {
      if (response.data && response.data.data && response.data.data.name) {
        dispatch({
          type: actionTypes.FETCH_GUID_DETAILS,
          guidDetails: response.data.data
        });
      }
    });
  };
};
var guidDetails = exports.guidDetails = function guidDetails(state) {
  return state[NAME];
};
var guidName = exports.guidName = function guidName(state) {
  return guidDetails(state).name;
};